import React from 'react';
import InternalForm from './Form';
import { FormProvider } from './FormContext';
import type { FormProps, FormProviderProps, FormState } from './Form.types';

const Form = <T extends FormState>(props: FormProviderProps<T> & FormProps) => {
  const {
    formRef,
    formState: values, 
    onFormStateChange, 
    formValidator,
    onSubmit,
    validateOnChange,
    autosave,
    autosaveDelayMs,
    ...otherProps
  } = props;

  return (
    <FormProvider 
      formRef={formRef}
      formState={values}
      onFormStateChange={onFormStateChange}
      formValidator={formValidator}
      onSubmit={onSubmit}
      validateOnChange={validateOnChange}
      autosave={autosave}
      autosaveDelayMs={autosaveDelayMs}
    >
      <InternalForm {...otherProps} noValidate />
    </FormProvider>
  );
};

export default Form;
export * from './Form.types';
export { useForm, useFormTyped } from './useForm';